import { ClientDto } from '../clienti/clienti';
import { MissionDto } from '../gestione-missioni/missioni-dto';
import {QRCodeDto} from "./qrcode-dto";

export const selectionButtonClass =
  ' p-4 rounded-3xl flex  justify-center items-center gap-4  hover:scale-105 transition-spring-500ms cursor-pointer';

export interface AdventureDto {
  id: string;
  status: string;
  description: string;
  shortDescription: string;
  name: string;
  maxMembers: number;
  createdAt: string;
  updatedAt?: string;
  clientFk?: string;
  client?: ClientDto;
  missions?: MissionDto[];
  adventureProgresses: AdventureProgressDto[];
  qrCodes: QRCodeDto[];
}

// Struttura allineata al backend (refactor Game→Adventure): il progress non ha più un id
// proprio e viene calcolato automaticamente lato server.
export interface AdventureProgressDto {
  adventureFk: string;
  teamFk: string;
  status: 'not_started' | 'in_progress' | 'completed';
  pointsEarned: number;
  startedAt: string | null;
  completedAt: string | null;
  createdAt: string;
  updatedAt?: string;
}

export interface CreateAdventure {
  name: string;
  description: string;
  shortDescription: string;
  status: string;
  clientFk: string;
  maxMembers: number;
}

export interface UpdateAdventure {
  name: string;
  description: string;
  shortDescription: string;
  status: string;
  clientFk: string;
  maxMembers: number;
}

export { MissionDto };
